import { Model } from 'vuex-orm';
import { clone } from 'lodash';
import moment from 'moment';

import User from '../user/model';

export default class Schedule extends Model {
  static entity = 'schedules';

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      day: this.attr(''),
      start_time: this.attr(''),
      work_length: this.attr(''),
      break_length: this.attr(''),

      user: this.belongsTo(User, 'user_id'),
    };
  }

  static serialize() {
    // console.log('serialize');
  }

  parse() {
    const clonedModel = clone(this);

    clonedModel.start_time = moment(clonedModel.start_time).format('h:mm A');

    return clonedModel;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/schedule/model.js